import {
    COUNTRYLISTPARTNER_SUCCESS,
    COUNTRYLISTPARTNER_FAILED,
    RESET_COUNTRYLISTPARTNER,
    LOADING_COUNTRYLISTPARTNER,
    NETWORK_ERROR_COUNTRYLISTPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetCountryListPartner = () => {
    return { type: RESET_COUNTRYLISTPARTNER };
};

const partnerCountryList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_COUNTRYLISTPARTNER });
    await partnerServices
        .post("countryList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerCountryListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerCountryListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_COUNTRYLISTPARTNER,
                payload: err
            });
        });
};

function partnerCountryListsuccess(data) {
    return {
        type: COUNTRYLISTPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerCountryListFailed(data) {
    return {
        type: COUNTRYLISTPARTNER_FAILED,
        payload: data,
    };
}

export { resetCountryListPartner, partnerCountryList }